import type { ChannelAccessUnits } from '@tradeoutlet/shared';
import { AudiencePicker } from '@/features/people/AudiencePicker';

/**
 * t167u: Access - departments, groups and buildings whose people can read the channel. Private: they read it
 * without being added; public: they're listed under their group and can join. Membership follows the group.
 */
export function ChannelAccessPicker({ value, onChange, disabled }: { value: ChannelAccessUnits; onChange: (v: ChannelAccessUnits) => void; disabled?: boolean }) {
  return (
    <div data-testid="channel-access-picker">
      <AudiencePicker kinds={['department', 'group', 'building']} disabled={disabled} placeholder="Search departments, groups and buildings" label="Give access to departments, groups or buildings"
        value={{ people: [], teams: value.team_ids, buildings: value.location_ids }}
        onChange={v => onChange({ team_ids: v.teams, location_ids: v.buildings ?? [] })} />
    </div>
  );
}
